import dayjs from 'dayjs';
import { DateRangeOptions } from '../typings';

export const getStartAndEndDate = (
  dateRangeOption: DateRangeOptions
): { startDate: string; endDate: string } => {
  const today = dayjs();

  switch (dateRangeOption) {
    case DateRangeOptions.LAST_MONTH:
      return {
        startDate: today.subtract(1, 'month').startOf('month').toISOString(),
        endDate: today.subtract(1, 'month').endOf('month').toISOString(),
      };
    case DateRangeOptions.LAST_3_MONTHS:
      return {
        startDate: today.subtract(3, 'month').startOf('day').toISOString(),
        endDate: today.endOf('day').toISOString(),
      };
    case DateRangeOptions.LAST_6_MONTHS:
      return {
        startDate: today.subtract(6, 'month').startOf('day').toISOString(),
        endDate: today.endOf('day').toISOString(),
      };
    case DateRangeOptions.LAST_12_MONTHS:
      return {
        startDate: today.subtract(12, 'month').startOf('day').toISOString(),
        endDate: today.endOf('day').toISOString(),
      };
    case DateRangeOptions.CURRENT_FINANCIAL_YEAR:
      // Assuming financial year starts on April 1st (common in many countries)
      const currentYear = today.month() >= 3 ? today.year() : today.year() - 1;
      return {
        startDate: dayjs(`${currentYear}-04-01`).startOf('day').toISOString(),
        endDate: today.endOf('day').toISOString(),
      };
    case DateRangeOptions.PREVIOUS_FINANCIAL_YEAR:
      // Assuming financial year starts on April 1st
      const prevFinancialYear =
        today.month() >= 3 ? today.year() - 1 : today.year() - 2;
      return {
        startDate: dayjs(`${prevFinancialYear}-04-01`)
          .startOf('day')
          .toISOString(),
        endDate: dayjs(`${prevFinancialYear + 1}-03-31`)
          .endOf('day')
          .toISOString(),
      };
    case DateRangeOptions.CUSTOM_DATE_RANGE:
      // For custom date range, typically you'd need additional parameters
      // Returning current day as a fallback since no custom dates are provided
      return {
        startDate: today.startOf('day').toISOString(),
        endDate: today.endOf('day').toISOString(),
      };
    default:
      return {
        startDate: today.startOf('day').toISOString(),
        endDate: today.endOf('day').toISOString(),
      };
  }
};
